import { Currency } from '@nemuru-eng/js-api-client';

export type MoneyAmount = { amount: number; currency: Currency };

export const amountToValueMoneyMapper = (money: MoneyAmount) => {
  return {
    value: money.amount,
    currency: money.currency,
  };
};
